<template>
    <ul :cn="componentName" class="
      dropdown-menu
      bg-white
      border border-gray-100
      text-left text-stone-900
      pt-1
      drop-shadow-md
      dark:border-transparent
      dark:bg-gray-700
      dark:text-white
      z-40
    ">
        <li v-for="(option, index) in availableOptions" :key="index" @click.prevent="click(option.key, option)"
            class="text-nowrap whitespace-nowrap">
            <a :disabled="option.disabled || option.loading"
                :class="{ 'cursor-not-allowed bg-gray-300  dark:bg-gray-800 dark:text-gray-500': option.disabled || option.loading, 'py-2 px-4 block text-nowrap whitespace-nowrap': true, 'hover:bg-gray-100 dark:hover:bg-gray-500': !option.disabled }"
                href="#">
                <span class="whitespace-nowrap">
                    <div class="flex flex-row" :title="__(option[title_key]) ?? null">
                        <img class="h-[13px] fa-fw" v-if="!option.loading && option.icon_url"
                            :src="this.$store.state.settings.url + option.icon_url">
                        <i v-if="!option.loading && option.icon" :class="option.icon" class="fa-fw"></i>
                        <SimpleLoadingIcon size="14px" v-if="option.loading"></SimpleLoadingIcon>
                        <translation class="pl-1" :ident="option.text">

                        </translation>

                    </div>

                </span>
            </a>
        </li>
    </ul>
</template>
<script>
import SimpleLoadingIcon from './SimpleLoadingIcon.vue';

export default {
    props: ["menuOptions", "data", "title_key"],
    inject: [],
    data() {
        return {};
    },
    computed: {
        componentName() {
            return "DropdownMenu";
        },
        availableOptions() {
            var emits = [];
            if (this.data && this.menuOptions) {
                emits = this.menuOptions;
            }
            var tmp = [];
            if (emits.length > 0) {
                for (let i in emits) {
                    var emit = JSON.parse(JSON.stringify(emits[i]));
                    if (emits[i].function == undefined || typeof emits[i].function != "function" || emits[i].function(this.data) == true) {
                        emit.disabled = false;
                    }
                    else {
                        emit.disabled = true;
                    }
                    if (emits[i].loadingFunction == undefined || typeof emits[i].loadingFunction != "function" || emits[i].loadingFunction(this.data) == false) {
                        emit.loading = false;
                    }
                    else {
                        emit.loading = true;
                    }
                    if(emits[i].display == undefined || typeof emits[i].display != "function" || emits[i].display(this.data) == true ){
                        tmp.push(emit);
                    }else{
                        //
                    }
                }
            }
            return tmp;
        }
    },
    methods: {
        click(key, option) {
            if(!option?.disabled){
                this.$emit("menu:" + option.key, option);
                this.$emit("event:menu", option);
            }
        },
    },
    components: { SimpleLoadingIcon }
};
</script>
<style scoped>

.dropdown-menu {
  position: absolute;
  z-index: 1010 !important; 
  background-color: #fff;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  list-style: none;
  padding: 0;
  margin: 0;
  min-width: 160px;
}
</style>
